import React from "react";
// import i from '../../../../../../public/assets/images/rocket-ico.svg'
// import i from '../../../../../../public/assets/images/eye-icon.svg'
// import i from '../../../../../../public/assets/images/compassi.svg'
const ourFoundation = [
  {
    title: "Our Mission",
    icon: "/assets/images/rocket-ico.svg",
    story:
      "Our mission is to simplify real estate investment for Nigerians at home and abroad through a secure digital platform. We build trust with verified properties, empower diaspora investors with seamless solutions, and foster growth by connecting credible developers with ready investors.",
  },
  {
    title: "Our Vision",
    icon: "/assets/images/eye-icon.svg",
    story:
      "To become the most trusted and accessible digital real estate marketplace that connects Nigerians across the globe with safe, transparent, and rewarding investment information and opportunities in Nigeria, thereby shaping a future where every Nigerian home or abroad, can confidently own a part of their homeland. ",
  },
  {
    title: "Our Purpose",
    icon: "/assets/images/compassi.svg",
    story:
      "To close the gap between home and abroad, ensuring every Nigerian, no matter where they live, can invest in Nigerian real estate with confidence and peace of mind. ",
  },
];

const OurFoundation = () => {
  return (
    <div className="w-full px-5 font-poppins flex items-center justify-center">
      <div className="flex flex-col gap-10 items-center justify-center max-w-[1272px]">
        <div className="flex flex-col gap-3.5">
          <h3 className="text-[36px] font-semibold">Our Foundation</h3>
          <span className="">
            Built on clear principles that guide everything we do
          </span>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-[35px]">
          {ourFoundation.map((member, i) => (
            <div
              className="flex flex-col gap-4 bg-[#F8F8F8] p-7 lg:p-10 shadow-custom2 rounded-[10px] items-center justify-"
              key={i}
              style={{
                boxShadow:
                  "0px 0.5px 0px 0.5px #00000026, 0px 1px 0.5px 0px #0000004D",
              }}
            >
              <div className="">
                <img
                  src={member.icon}
                  className="rounded-full h-full w-full object-cover"
                  alt=""
                />
              </div>
              <h2 className="">{member.title}</h2>
              <div className="py-4 flex flex-col gap-4 items-center justify-center">
                {/* <h3 className="text-textBlac3 text-center text-[22px] font-poppins font-medium">
                    {member.name}
                  </h3> */}
                <p className="text-textBlack3 text-center leading-[22px] font-[300] tracking-[0%] font-poppins">
                  {member.story}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurFoundation;
